var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createUseStyles } from "react-jss";
import { GridColumnWidth } from "../types/table";
import { isArrayDefined } from "./isDefined";
import { COL_PIXEL_MAP } from "./sizing";
export function getGridColumns(_a) {
    var headings = _a.headings, hasDrawer = _a.hasDrawer, actionAtEnd = _a.actionAtEnd, actionAtStart = _a.actionAtStart;
    if (!isArrayDefined(headings))
        return undefined;
    var columns = "";
    var hasSomeWidths = headings.some(function (heading) { return heading.width; });
    if (hasSomeWidths) {
        columns = getWidthColumns(headings);
    }
    else {
        columns = getDefaultColumns(headings);
    }
    columns = hasDrawer ? "".concat(columns, " 100px") : columns;
    columns = actionAtStart ? "32px ".concat(columns) : columns;
    columns = actionAtEnd ? "".concat(columns, " 33px") : columns;
    return columns;
}
export function getDefaultColumns(headings) {
    var columns = "";
    headings === null || headings === void 0 ? void 0 : headings.forEach(function (_, i) {
        if (i === 0)
            return (columns = GridColumnWidth.Fragment);
        return (columns += " ".concat(GridColumnWidth.Fragment));
    });
    return columns;
}
export function getWidthColumns(headings) {
    var _a;
    var setGridColumns = function (headings) {
        var gridColumns = [];
        headings.forEach(function (heading) {
            var _a;
            if (Array.isArray(heading.width) || typeof heading.width == "object") {
                gridColumns.push(GridColumnWidth.Fragment);
            }
            else {
                if (heading.width === GridColumnWidth.AUTO) {
                    gridColumns.push(GridColumnWidth.Fragment);
                }
                else {
                    gridColumns.push((_a = heading.width) !== null && _a !== void 0 ? _a : GridColumnWidth.Fragment);
                }
            }
        });
        return gridColumns;
    };
    return (_a = buildGridColumnWidthToString(setGridColumns(headings))) !== null && _a !== void 0 ? _a : "";
}
export var buildGridColumnWidthToString = function (columns) {
    return columns.reduce(function (gridColumns, column) { return gridColumns + " " + COL_PIXEL_MAP.get(column); }, "");
};
function getGridTemplateColumns(headings, drawer, hasActionAtStart, hasActionAtEnd) {
    var gridColumnsString = getGridColumns({
        headings: headings,
        hasDrawer: !!drawer,
        actionAtStart: hasActionAtStart,
        actionAtEnd: !!hasActionAtEnd,
    });
    var numberOfColumns = headings.length;
    var gridColumns = {
        gridTemplateColumns: "".concat(gridColumnsString),
        "-ms-grid-columns": "".concat(gridColumnsString),
    };
    if (drawer && numberOfColumns) {
        gridColumns = __assign(__assign({}, gridColumns), { "grid-template-rows": "auto", gridTemplateAreas: "\n          \"".concat(getMainTemplateAreas(hasActionAtStart ? numberOfColumns + 1 : numberOfColumns), " data-drawer-toggle ").concat(hasActionAtEnd ? "data-action" : "", "\"\n          \"").concat(getDrawerTemplateAreas(numberOfColumns +
                1 +
                (hasActionAtStart ? 1 : 0) +
                (hasActionAtEnd ? 1 : 0)), "\"\n        ") });
    }
    else if (numberOfColumns) {
        gridColumns = __assign(__assign({}, gridColumns), { gridTemplateAreas: "\"".concat(getMainTemplateAreas(hasActionAtStart ? numberOfColumns + 1 : numberOfColumns), " ").concat(hasActionAtEnd ? "data-action" : "", "\"") });
    }
    return gridColumns;
}
var useStyles = createUseStyles({
    // @ts-ignore
    gridColumns: function (_a) {
        var headings = _a.headings, drawer = _a.drawer, hasActionAtStart = _a.hasActionAtStart, hasActionAtEnd = _a.hasActionAtEnd;
        return getGridTemplateColumns(headings, drawer, hasActionAtStart, hasActionAtEnd);
    },
});
export function useGridColumnsClasses(props) {
    // @ts-ignore
    return useStyles(props);
}
export var DATA_COL_INDEX = "data-colindex-";
export var getMainTemplateAreas = function (columns) {
    if (typeof columns == "number") {
        var colIndexMain = "";
        for (var index = 0; index < columns; index++) {
            colIndexMain += "".concat(DATA_COL_INDEX).concat(index + 1, " ");
        }
        return colIndexMain;
    }
};
export var DATA_COL_INDEX_DRAWER = "data-colindex-drawer";
export var getDrawerTemplateAreas = function (columns) {
    if (typeof columns == "number") {
        var colIndexDrawer = "";
        for (var index = 0; index < columns; index++) {
            colIndexDrawer += "".concat(DATA_COL_INDEX_DRAWER, " ");
        }
        return colIndexDrawer;
    }
};
